import { gql as e } from "@apollo/client";
const t = e`
  mutation SendOtpCode($email: String!) {
    sendEmailVerifyOTP(input: { email: $email })
  }
`;
export {
  t as default
};
//# sourceMappingURL=sendEmailVerifyOTP.js.map
